import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface ConfirmDialogConfig {
  title: string;
  message: string;
}

@Component({
  standalone: false,
  selector: 'caaks-confirm-dialog',
  templateUrl: 'confirm-dialog.template.html',
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogConfig) {}
}
